<template>
  <div class="auth" id="auth" name="auth">
    <div class="top">
      <NavTop activeIndex="3" @changCurrent="changCurrent"></NavTop>
    </div>
    <div class="content">
      <div class="content-content" style="margin-top: 100px">
        <div class="content-left">
          <div class="left-bom">
            <div class="" style="font-size: 22px; font-weight: bold; margin-bottom: 30px;text-align: center;">
              个人中心
            </div>
            <div :class="current == index ? 'left-item active' : 'left-item'" v-for="(item, index) in leftList"
              :key="index" @click="changtab(index)">
              <img :src="item.img" alt="" style="
                  width: 16px;
                  height: 16px;
                  display: block;
                  margin-right: 10px;
                " v-if="current == index" />
              <img :src="item.img1" alt="" style="
                  width: 16px;
                  height: 16px;
                  display: block;
                  margin-right: 10px;
                " v-else />
              <div class="">{{ item.name }}</div>
            </div>
            <div :class="current == 6 ? 'left-item active' : 'left-item'" @click="changtab(6)"
              v-if="userInfo.isLive == 0 || userInfo.isLive == 3">
              <img src="../assets/images/my-concern-on.png" alt="" style="
                  width: 16px;
                  height: 16px;
                  display: block;
                  margin-right: 10px;
                " v-if="current == 6" />
              <img src="../assets/images/my-concern-off.png" alt="" style="
                  width: 16px;
                  height: 16px;
                  display: block;
                  margin-right: 10px;
                " v-else />
              <div class="">注册成为主播</div>
            </div>

            <div :class="current == 7 ? 'left-item active' : 'left-item'" @click="changtab(7)"
              v-if="userInfo.isLive == 1">
              <img src="../assets/images/my-subscribe-on.png" alt="" style="
                  width: 16px;
                  height: 16px;
                  display: block;
                  margin-right: 10px;
                " v-if="current == 7" />
              <img src="../assets/images/my-subscribe-off.png" alt="" style="
                  width: 16px;
                  height: 16px;
                  display: block;
                  margin-right: 10px;
                " v-else />
              <div class="">我要开播</div>
            </div>
            <div :class="current == 8 ? 'left-item active' : 'left-item'" @click="changtab(8)"
              v-if="userInfo.isLive == 2">
              <img src="../assets/images/my-subscribe-on.png" alt="" style="
                  width: 16px;
                  height: 16px;
                  display: block;
                  margin-right: 10px;
                " v-if="current == 7" />
              <img src="../assets/images/my-subscribe-off.png" alt="" style="
                  width: 16px;
                  height: 16px;
                  display: block;
                  margin-right: 10px;
                " v-else />
              <div class="">申请正在审核</div>
            </div>
          </div>
        </div>
        <div class="content-right" v-if="current == 0 && !show">
          <div class="" style="display: flex; justify-content: end">
            <div class="" style="
                border: 1px solid #999;
                border-radius: 2px;
                padding: 0 5px;
                color: #999;
              " @click="current = 1">
              修改资料
            </div>
          </div>
          <img :src="headimg" alt="" style="
              width: 116px;
              height: 116px;
              border-radius: 50%;
              display: block;
              margin: 0 auto;
            " />
          <div class="" style="font-size: 22px; font-weight: bold; text-align: center">
            {{ userInfo.nickname }}
          </div>
          <div class="" style="
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 20px 0;
            ">
            <div class="" style="
                color: #fff;
                background-color: #bbb;
                padding: 0 5px;
                font-size: 12px;
                border-radius: 2px;
              ">
              Lv.{{ userInfo.level }}
            </div>
            <div class="" style="width: 392px; height: 12px; margin: 0 30px">
              <el-progress :percentage="percentage" style="width: 392px; height: 12px">
              </el-progress>
            </div>
            <div class="" style="color: #777; font-weight: bold">
              {{ userInfo.experience }} / {{ experience }}
            </div>
          </div>
          <div class="" style="display: flex; align-items: center; justify-content: center">
            <div class="" style="text-align: center">
              <div class="" style="font-size: 20px; font-weight: bold">
                Lv.{{ userInfo.level }}
              </div>
              <div class="" style="font-size: 16px">等级</div>
            </div>
            <div class="line"></div>
            <div class="" style="text-align: center">
              <div class="" style="font-size: 20px; font-weight: bold">
                {{ userInfo.experience }}
              </div>
              <div class="" style="font-size: 16px">经验值</div>
            </div>
            <div class="line"></div>
            <div class="" style="text-align: center">
              <div class="" style="font-size: 20px; font-weight: bold">
                {{ userInfo.money }}
              </div>
              <div class="" style="font-size: 16px">金币</div>
            </div>
          </div>
          <div class="" style="
              width: 100%;
              height: 1px;
              background-color: #eee;
              margin: 40px 0;
            "></div>
          <div class="" style="font-size: 22px; font-weight: bold">
            账号管理
          </div>
          <div class="" style="
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 30px;
            ">
            <div class="" style="
                width: 406px;
                height: 121px;
                border: 1px solid #eee;
                padding: 26px 30px 30px;
                display: flex;
                align-items: center;
                margin-right: 30px;
                border-radius: 5px;
              ">
              <img src="../assets/images/phone.png" alt="" style="width: 64px; height: 64px; display: block" />
              <div class="" style="flex: 1">
                <div class="" style="font-size: 18px; font-weight: bold">
                  我的手机
                </div>
                <div class="" style="font-size: 12px; color: #999">
                  已绑定手机号码
                </div>
              </div>
              <div class="" style="
                  background-color: #4b72f6;
                  color: #fff;
                  padding: 5px 10px;
                  border-radius: 5px;
                " @click="show = true">
                更换手机
              </div>
            </div>
            <div class="" style="
                width: 406px;
                height: 121px;
                border: 1px solid #eee;
                padding: 26px 30px 30px;
                display: flex;
                align-items: center;
                border-radius: 5px;
              ">
              <img src="../assets/images/password.png" alt="" style="width: 64px; height: 64px; display: block" />
              <div class="" style="flex: 1">
                <div class="" style="font-size: 18px; font-weight: bold">
                  我的密码
                </div>
                <div class="" style="font-size: 12px; color: #999">
                  已经设置密码
                </div>
              </div>
              <div class="" style="
                  background-color: #4b72f6;
                  color: #fff;
                  padding: 5px 10px;
                  border-radius: 5px;
                " @click="goRet">
                更改密码
              </div>
            </div>
          </div>
        </div>
        <!-- 订单详情 -->
        <div class="content-right" v-if="current == 0 && show">
          <div class="" style="display: flex; align-items: center" @click="show = false">
            <i class="el-icon-arrow-left"></i>
            <div class="" style="font-size: 18px; font-weight: bold">
              改绑手机
            </div>
          </div>
          <div class="" style="
              background-color: #f6f6f6;
              width: 100%;
              height: 94px;
              text-align: center;
              margin-top: 50px;
              line-height: 94px;
              font-size: 20px;
            ">
            绑定手机
          </div>
          <el-form :model="LoginUser" status-icon ref="ruleForm" class="demo-ruleForm" style="padding: 0 15px">
            <el-form-item prop="name">
              <div class="" style="
                  display: flex;
                  display: flex;
                  align-items: center;
                  border-bottom: 1px solid #e6e6e6;
                ">
                <div class="" style="
                    line-height: 20px;
                    border: 1px solid #fff;
                    height: 20px;
                    box-sizing: border-box;
                    margin-right: 10px;
                  ">
                  +86
                </div>
                <div class="" style="flex: 1">
                  <el-input type="idcard" placeholder="请输入手机号" v-model="newPhone" maxlength="11"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="pass">
              <div class="pass-box" style="display: flex;justify-content: space-between;">
                <div class="" style="border-bottom: 1px solid #e6e6e6;flex: 1;margin-right: 10px;">
                  <el-input type="number" placeholder="请输入验证码" v-model="LoginUser.code" size="mini"
                    maxlength="6"></el-input>
                </div>
                <div class="" @click="getCode" style="position: relative;width: 84px;">
                  <div class=""
                    style="color: #000;cursor: pointer;background-color: #eee;position: absolute;width: 84px;right: 0;height: 27px;line-height: 27px;text-align: center;bottom: 0;border-radius: 4px;">
                    {{ buttonText }}</div>
                </div>
              </div>
            </el-form-item>
            <div class="" style="margin-top: 35px; margin-bottom: 10px">
              <div class="">
                <el-button size="medium" type="info" style="
                    width: 270px;
                    height: 40px;
                    padding: 0;
                    border-radius: 5px;
                    background-color: #4b72f6;
                    border: none;
                    color: #666 !important;
                  " round @click="bindPhone">绑定</el-button>
              </div>
            </div>
          </el-form>
        </div>
        <!-- 我的剧本 -->
        <div class="content-right" v-if="current == 1">
          <div class="" style="display: flex; align-items: center">
            <div class="" style="
                width: 4px;
                height: 20px;
                background-color: #4b72f6;
                margin-right: 10px;
                border-radius: 10px;
              "></div>
            <div class="" style="font-size: 18px; font-weight: bold">
              我的资料
            </div>
          </div>
          <div class="" style="margin-top: 50px">头像:</div>
          <div class="">
            <el-upload class="" action="https://476.new.lingchuang.co/api/common/upload" :on-success="onSuccess8"
              :headers="headers" :show-file-list="false">
              <div class="" style="display: flex; align-items: center; margin-top: 30px">
                <img :src="headimg" alt="" style="width: 100px; height: 100px; border-radius: 10px" />
              </div>
            </el-upload>
          </div>
          <div class="" style="margin-top: 50px">昵称:</div>
          <div class="" style="border: 1px solid #eee; border-radius: 5px">
            <el-input v-model="nickname" placeholder="请输入内容"></el-input>
          </div>
          <div class="" style="display: flex; align-items: center; margin-top: 20px">
            <!-- <div class="" style="margin-right: 30px;">
                            <div class="" style="">性别:</div>
                            <div class="" style="border: 1px solid #eee;border-radius: 5px;">
                                <el-select v-model="gender" placeholder="请选择" @change="genderChang">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div> -->

            <!-- <div class="">
              <div class="" style="">出生日期:</div>
              <div class="" style="border: 1px solid #eee; border-radius: 5px">
                <el-date-picker v-model="birthday" type="date" placeholder="选择日期" @change="dateChange"
                  value-format="yyyy-MM-dd" format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </div> -->
          </div>
          <el-button size="medium" type="info" @click="editInfobtn" style="
              width: 150px;
              height: 40px;
              padding: 0;
              border-radius: 5px;
              background-color: #4b72f6;
              border: none;
              color: #666 !important;
              color: #fff;
              margin-top: 50px;
            " round>保存更改</el-button>
        </div>
        <div class="content-right" v-if="current == 5">
          <div class="" style="display: flex; align-items: center">
            <div class="" style="
                width: 4px;
                height: 20px;
                background-color: #4b72f6;
                margin-right: 10px;
                border-radius: 10px;
              "></div>
            <div class="" style="font-size: 18px; font-weight: bold">
              我的私信
            </div>
          </div>
        </div>
        <!-- 资料与账号 -->
        <div class="content-right" v-if="current == 2" v-loading="loading">
          <div class="" style="display: flex; align-items: center">
            <div class="" style="
                width: 4px;
                height: 20px;
                background-color: #4b72f6;
                margin-right: 10px;
                border-radius: 10px;
              "></div>
            <div class="" style="font-size: 18px; font-weight: bold">
              我的关注
            </div>
          </div>

          <div class="" style="
              display: flex;
              padding: 30px 0;
              border-bottom: 1px solid #eee;
            " v-for="(item, index) in guanzhuList" :key="index">
            <img :src="baseUrl + item.avatar" alt="" style="
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: block;
                margin-right: 20px;
              " />
            <div class="" style="flex: 1">
              <div class="" style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                ">
                <div class="" style="flex: 1">
                  <div class="">
                    {{ item.nickname }}
                  </div>
                  <div class="" style="font-size: 12px; color: #777">
                    一起来聊球
                  </div>
                </div>
                <div class="" style="font-size: 12px" @click="cancelGUanhzu(item)">
                  <el-button> 取消关注</el-button>
                </div>
              </div>

              <div class="" style="
                  display: flex;
                  margin-top: 20px;
                  justify-content: space-between;
                ">
                <div class="" style="" v-if="item.live">
                  <div class="" style="font-size: 20px; font-weight: bold; width: 235px">
                    {{ item.live.title }}
                  </div>
                  <div class="" style="width: 235px; height: 132px; position: relative"
                    @click="goliveDetail(item.live.user_id)">
                    <img :src="baseUrl + item.live.cover_image" alt=""
                      style="width: 235px; height: 132px; border-radius: 5px" />
                    <div class="" style="
                        background-color: #4b72f6;
                        color: #fff;
                        padding: 0 5px;
                        position: absolute;
                        bottom: 10px;
                        left: 10px;
                        font-size: 12px;
                        border-radius: 2px;
                      ">
                      直播中
                    </div>
                    <div class="" style="
                        display: flex;
                        align-items: center;
                        color: #fff;
                        position: absolute;
                        right: 10px;
                        bottom: 10px;
                      ">
                      <img src="../assets/images/fire.png" alt="" style="
                          width: 14px;
                          height: 14px;
                          display: block;
                          margin-right: 2px;
                        " />
                      <div class="">{{ item.live.heat }}</div>
                    </div>
                  </div>
                </div>
                <div class="" style="" v-else>
                  <div class="" style="font-size: 20px; font-weight: bold; width: 235px">
                    暂无直播
                  </div>
                  <div class="" style="width: 235px; height: 132px; position: relative">
                    <img src="https://sta.yyzb456.top/web/assets/yy/img/live-cover.png" alt=""
                      style="width: 235px; height: 132px; border-radius: 5px" />
                  </div>
                </div>


                <div class="" style="display: flex" v-if="item.match_list.length > 0">
                  <div class="" style="margin-right: 20px">
                    <div class="" style="font-size: 20px; font-weight: bold">
                      {{ item.match_list[0].match_time.substring(5, 16) }}
                    </div>
                    <div class="" style="
                        width: 235px;
                        height: 132px;
                        border: 1px solid #eee;
                        border-radius: 2px;
                        padding: 20px;
                        font-size: 12px;
                        border-radius: 5px;
                      ">
                      <div class="" style="display: flex; align-items: center">
                        <img src="../assets/images/51be7cde8b89133a0996be3a55802701.png" alt=""
                          style="width: 12px; height: 12px; margin-right: 5px" />
                        <div class="" style="font-size: 12px; flex: 1">
                          {{ item.match_list[0].league_name }}
                        </div>

                        <div class="">
                          <div class="" style="text-align: right; font-size: 18px"
                            v-if="item.match_list[0].live_status == 1">
                            直播中...
                          </div>
                          <div class="" v-if="item.match_list[0].live_status == 0">
                            <div class="" style="
                            color: #4b72f6;
                            border: 1px solid #4b72f6;
                            font-size: 12px;
                            padding: 0 10px;
                            border-radius: 2px;
                          " v-if="item.match_list[0].is_reservation" @click="qxyuyue(item.match_list[0].id)">
                              已预约
                            </div>
                            <div class="" style="
                            color: #4b72f6;
                            border: 1px solid #4b72f6;
                            font-size: 12px;
                            padding: 0 10px;
                            border-radius: 2px;
                          " v-else @click="goyuyue(item.match_list[0].id)">
                              预约
                            </div>
                          </div>
                          <div class="" style="text-align: right; font-size: 18px"
                            v-if="item.match_list[0].live_status == 2">
                            已结束
                          </div>

                        </div>








                      </div>
                      <div class="" style="
                          display: flex;
                          align-items: center;
                          margin-top: 15px;
                        ">
                        <img :src="item.match_list[0].home_team_logo_text" alt="" style="
                            width: 24px;
                            height: 24px;
                            display: block;
                            margin-right: 10px;
                          " />
                        <div class="">
                          {{ item.match_list[0].home_team_name }}
                        </div>
                      </div>
                      <div class="" style="
                          display: flex;
                          align-items: center;
                          margin-top: 10px;
                        ">
                        <img :src="item.match_list[0].away_team_logo_text" alt="" style="
                            width: 24px;
                            height: 24px;
                            display: block;
                            margin-right: 10px;
                          " />
                        <div class="">
                          {{
                            item.match_list[0].away_team_name
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="" v-if="item.match_list.length > 1">
                    <div class="" style="font-size: 20px; font-weight: bold">
                      {{ item.match_list[1].match_time.substring(5, 16) }}
                    </div>
                    <div class="" style="
                        width: 235px;
                        height: 132px;
                        border: 1px solid #eee;
                        border-radius: 2px;
                        padding: 20px;
                        font-size: 12px;
                        border-radius: 5px;
                      ">
                      <div class="" style="display: flex; align-items: center">
                        <img src="../assets/images/51be7cde8b89133a0996be3a55802701.png" alt=""
                          style="width: 12px; height: 12px; margin-right: 5px" />
                        <div class="" style="font-size: 12px; flex: 1">
                          {{ item.match_list[1].league_name }}
                        </div>


                        <div class="">
                          <div class="" style="text-align: right; font-size: 18px"
                            v-if="item.match_list[1].live_status == 1">
                            直播中...
                          </div>
                          <div class="" v-if="item.match_list[1].live_status == 0">
                            <div class="" style="
                            color: #4b72f6;
                            border: 1px solid #4b72f6;
                            font-size: 12px;
                            padding: 0 10px;
                            border-radius: 2px;
                          " v-if="item.match_list[1].is_reservation" @click="qxyuyue(item.match_list[1].id)">
                              已预约
                            </div>
                            <div class="" style="
                            color: #4b72f6;
                            border: 1px solid #4b72f6;
                            font-size: 12px;
                            padding: 0 10px;
                            border-radius: 2px;
                          " v-else @click="goyuyue(item.match_list[1].id)">
                              预约
                            </div>
                          </div>
                          <div class="" style="text-align: right; font-size: 18px"
                            v-if="item.match_list[1].live_status == 2">
                            已结束
                          </div>
                        </div>




                      </div>
                      <div class="" style="
                          display: flex;
                          align-items: center;
                          margin-top: 15px;
                        ">
                        <img :src="item.match_list[1].home_team_logo_text" alt="" style="
                            width: 24px;
                            height: 24px;
                            display: block;
                            margin-right: 10px;
                          " />
                        <div class="">
                          {{
                            item.match_list[1].home_team_name
                          }}
                        </div>
                      </div>
                      <div class="" style="
                          display: flex;
                          align-items: center;
                          margin-top: 10px;
                        ">
                        <img :src="item.match_list[1].away_team_logo_text" alt="" style="
                            width: 24px;
                            height: 24px;
                            display: block;
                            margin-right: 10px;
                          " />
                        <div class="">
                          {{ item.match_list[1].away_team_name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-right" v-if="current == 3" v-loading="loading">
          <!-- <div class="" style="font-size: 20px;font-weight: bold;"> 05月21日 今天</div> -->
          <div class="" style="display: flex; align-items: center">
            <div class="" style="
                width: 4px;
                height: 20px;
                background-color: #4b72f6;
                margin-right: 10px;
                border-radius: 10px;
              "></div>
            <div class="" style="font-size: 18px; font-weight: bold">
              我的预约
            </div>
          </div>
          <div class="" style="margin-top: 30px; width: 100%" v-if="yuyueList.length > 0">

            <div class="" v-for="(item, index) in yuyueList" :key="index" style="
                height: 100px;
                background-color: #fff;
                margin: 0 auto 15px;
                border-right: 6px solid #4b72f6;
                box-sizing: border-box;
                border: 1px solid #999;
                border-radius: 5px;
                overflow: hidden;
              ">
              <div class="" style="
                  display: flex;
                  align-items: center;
                  height: 100px;
                  border-radius: 5px;
                ">
                <div class="" style=" margin-left: 24px">
                  <div class="" style="color: #777">{{ item.match.league_name }}</div>
                  <div class="" style="font-size: 18px; font-weight: bold">
                    {{ item.match.match_time.substring(5, 16) }}
                  </div>
                </div>
                <div class="" style="display: flex; align-items: center; margin-right: 20px">
                  <div class="" style="display: flex; align-items: center; font-size: 16px">
                    <div class="" style="
                        width: 96px;
                        text-align: right;
                        margin-right: 5px;
                        font-size: 12px;
                      ">
                      {{ item.match.home_team_name }}
                    </div>
                    <img :src="item.match.home_team_logo_text" alt=""
                      style="width: 42px; height: 42px; display: block" />
                  </div>
                  <div class="" style="font-size: 18px; font-weight: bold; padding: 0 15px">
                    VS
                  </div>
                  <div class="" style="display: flex; align-items: center; font-size: 16px">
                    <img :src="item.match.away_team_logo_text" alt="" style="
                        width: 42px;
                        height: 42px;
                        display: block;
                        margin-right: 5px;
                      " />
                    <div class="" style="width: 96px; font-size: 12px">
                      {{ item.match.away_team_name }}
                    </div>
                  </div>
                </div>
                <div class="" style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    
                  " v-if="item.anchor_list.length > 0">
                  <div class="" @click="leftSlide(index)">
                    <i class="el-icon-arrow-left" style="font-size: 20px; color: #999; margin-right: 10px"></i>
                  </div>
                  <div class="" style="width: 216px">
                    <div class="scroll_wrapper1" style="
                        display: flex;
                        align-items: center;
                        overflow-x: scroll;
                        width: 216px;
                        margin: 0 auto;
                      " ref="wrapperCon">
                      <div class="" v-for="(imange, inc) in item.anchor_list" :key="inc" style=""
                        @click="goliveDetail(imange.id)">
                        <div class="" style="
                            display: block;
                            width: 36px;
                            height: 36px;
                            border-radius: 50%;
                            position: relative;
                            margin: 0 4px;
                          ">
                          <img :src="baseUrl + imange.avatar" alt="" style="
                              display: block;
                              width: 36px;
                              height: 36px;
                              border-radius: 50%;
                            " />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="" @click="rightSlide(index)">
                    <i class="el-icon-arrow-right" style="font-size: 20px; color: #999; margin-left: 10px"></i>
                  </div>
                </div>


                <!-- <div class="" style="padding: 5px 14px;background-color: #d8d8d8;border-radius: 60px;margin-left: 30px;"
                  @click="qxyuyue(item.match_id)">
                  已预约</div> -->

                <div class="">
                  <div class="" style="text-align: right; font-size: 18px" v-if="item.match.live_status == 1">
                    直播中
                  </div>
                  <div class="" style="display: flex; justify-content: end" v-if="item.match.live_status == 0">
                    <div class="" style="
                background-color: #eee;
                color: #333;
                padding: 0 20px;
                border-radius: 60px;font-size: 18px
              "  @click="qxyuyue(item)">
                      已预约
                    </div>
                  </div>
                  <div class="" style="text-align: right; font-size: 18px" v-if="item.match.live_status == 2">
                    已结束
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-right" v-if="current == 4" v-loading="loading">
          <div class="" style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 50px;
            ">
            <div class="" style="display: flex; align-items: center">
              <div class="" style="
                  width: 4px;
                  height: 20px;
                  background-color: #4b72f6;
                  margin-right: 10px;
                  border-radius: 10px;
                "></div>
              <div class="" style="font-size: 18px; font-weight: bold">
                我的反馈
              </div>
            </div>
            <div class="" style="display: flex; align-items: center; cursor: pointer" @click="goFeed">
              <img src="../assets/images/feedback-btn.png" alt="" style="
                  width: 19px;
                  height: 21px;
                  display: block;
                  margin-right: 5px;
                " />
              <div class="" style="color: #575be5">去反馈</div>
            </div>
          </div>
          <div class="" v-if="showDetail">

            <div class="" @click="showDetail = false" style="margin-top: -40px;">
              <i class="el-icon-arrow-left"></i>
              返回
            </div>
            <div class="" style=" margin-top: 50px;">
              反馈内容:{{ feedItem.content }}
            </div>
            <div class="" style="margin-top: 20px">
              联系方式:{{ feedItem.contact }}
            </div>
            <div class="" style="margin-top: 20px">
              图片:
            </div>
            <div class="" style="display: flex; align-items: center; margin-top: 20px">
              <div class="" v-for="(item, index) in feedItem.image" :key="index"
                style="width: 50px; border-radius: 5px; margin-right: 10px">
                <img :src="item" alt="" style="width: 50px; height: 50px; border-radius: 5px" />
              </div>
            </div>
            <div class="" style="margin-top: 20px">
              是否处理:{{ feedItem.status == 0 ? '未处理' : '已处理' }}
            </div>
            <div class="" v-if="feedItem.status == 1" style="margin-top: 20px">
              客服处理内容:{{ feedItem.reply }}
            </div>
            <div class="" v-if="feedItem.status == 1" style="margin-top: 20px">
              客服处理时间:{{ feedItem.reply_time }}
            </div>

          </div>
          <div class="" v-else>
            <div class="" v-for="(item, index) in fankuiList" :key="index" style="
              display: flex;
              align-items: center;
              padding: 20px 0;
              border-bottom: 1px solid #eee;
            ">
              <img src="../assets/images/feedback-item.png" alt="" style="
                width: 18px;
                height: 18px;
                display: block;
                margin-right: 10px;
              " />
              <div class="" style="flex: 1">
                {{ item.content }}
              </div>
              <div class="" style="font-size: 16px; font-weight: bold; color: #575be5;margin-left:20px;"
                @click="seeDetail(item)">
                详情
              </div>
              <div class="" style="margin: 0 20px 0 50px">
                {{ item.create_time }}
              </div>
            </div>
          </div>


          <div class="" style="display: flex;justify-content: center;" v-if="!showDetail">
            <el-pagination layout="prev, pager, next" :total="fankuiTotal" background @prev-click="prevFankui"
              @next-click="nextFankui" @current-change="currentFankui">
            </el-pagination>

          </div>

        </div>
        <div class="content-right" v-if="current == 6" v-loading="loading">
          <div class="" style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 50px;
            ">
            <div class="" style="display: flex; align-items: center">
              <div class="" style="
                  width: 4px;
                  height: 20px;
                  background-color: #4b72f6;
                  margin-right: 10px;
                  border-radius: 10px;
                "></div>
              <div class="" style="font-size: 18px; font-weight: bold">
                注册成为主播
              </div>
            </div>
          </div>
          <div class="" style="display: flex; align-items: center">
            <div class="" style="width: 120px">
              <span style="color: red">*</span>姓名
            </div>
            <div class="">
              <div class="" style="border: 1px solid #eee; border-radius: 5px">
                <el-input v-model="realName" placeholder="输入您的真实姓名(必填)"></el-input>
              </div>
            </div>
          </div>
          <div class="" style="display: flex; align-items: center">
            <div class="" style="width: 120px">
              <span style="color: red">*</span>身份证正面照片
            </div>
            <div class="">
              <el-upload class="upload-demo" action="https://476.new.lingchuang.co/api/common/upload"
                :on-success="onSuccess1" :headers="headers" :show-file-list="false">
                <div class="" style="display: flex; align-items: center; margin-top: 30px">
                  <img :src="frontCard" alt="" style="width: 320px; height: 184px; border-radius: 10px"
                    v-if="frontCard" />
                  <img src="../assets/imgs/card1.png" alt="" style="width: 320px; height: 184px; border-radius: 10px"
                    v-else />
                </div>
              </el-upload>
            </div>
          </div>
          <div class="" style="display: flex; align-items: center">
            <div class="" style="width: 120px">
              <span style="color: red">*</span>身份证反面照片
            </div>
            <div class="">
              <el-upload class="upload-demo" action="https://476.new.lingchuang.co/api/common/upload"
                :on-success="onSuccess2" :headers="headers" :show-file-list="false">
                <div class="" style="display: flex; align-items: center; margin-top: 30px">
                  <img :src="reverseCard" alt="" style="width: 320px; height: 184px; border-radius: 10px"
                    v-if="reverseCard" />
                  <img src="../assets/imgs/card2.png" alt="" style="width: 320px; height: 184px; border-radius: 10px"
                    v-else />
                </div>
              </el-upload>
            </div>
          </div>
          <div class="" style="display: flex; align-items: center">
            <div class="" style="width: 120px">
              <span style="color: red">*</span>手持身份证照片
            </div>
            <div class="">
              <el-upload class="upload-demo" action="https://476.new.lingchuang.co/api/common/upload"
                :on-success="onSuccess3" :headers="headers" :show-file-list="false">
                <div class="" style="display: flex; align-items: center; margin-top: 30px">
                  <img :src="handHeld" alt="" style="width: 320px; height: 184px; border-radius: 10px"
                    v-if="handHeld" />
                  <img src="../assets/imgs/card3.png" alt="" style="width: 320px; height: 184px; border-radius: 10px"
                    v-else />
                </div>
              </el-upload>
            </div>
          </div>
          <div class="" style="display: flex; align-items: center; margin-top: 20px">
            <div class="" style="width: 120px">
              <span style="color: red">*</span>自我描述
            </div>
            <div class="" style="width: 100%">
              <el-input type="textarea"
                placeholder="1.主播经验   2.曾在哪些平台担任主播   3.曾获哪些奖项   4.擅长哪些类型的赛事转播(足球、篮球、电竞、娱乐、其他)   5.至少15个字"
                v-model="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500"
                :show-word-limit="false"></el-input>
            </div>
          </div>
          <div class="" style="
              margin-top: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
            ">
            <div class="" style="width: 16px; height: 16px; margin-right: 5px" @click="check = !check">
              <img src="../assets/imgs/checked.png" alt="" style="width: 16px; height: 16px; display: block"
                v-if="check" />
              <img src="../assets/imgs/check.png" alt="" style="width: 16px; height: 16px; display: block" v-else />
            </div>
            本人已阅读并同意
            <span style="color: #4b72f6" @click="goLOk">《直播主播入驻协议》</span>
            并遵守协议条款。
          </div>
          <div class="" style="
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 50px;
            ">
            <div class="" style="
                color: #4b72f6;
                border: 1px solid #4b72f6;
                width: 140px;
                height: 44px;
                text-align: center;
                line-height: 44px;
                border-radius: 5px;
                margin-right: 30px;
              ">
              取消
            </div>
            <div class="" style="
                color: #fff;
                width: 140px;
                height: 44px;
                text-align: center;
                line-height: 44px;
                border-radius: 5px;
                background-color: #4b72f6;
              " @click="submitApply">
              确定
            </div>
          </div>
        </div>
        <div class="content-right" v-if="current == 7" style="padding: 0" v-loading="loading">
          <div class="" style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="" style="width: 168px; height: 80px; position: relative">
              <div class="" style="
                  width: 168px;
                  height: 80px;
                  text-align: center;
                  line-height: 80px;
                  font-size: 20px;
                  font-weight: bold;
                  position: absolute;
                  z-index: 2;
                ">
                直播列表
              </div>
              <img src="../assets/imgs/zbbg.png" alt="" style="
                  width: 168px;
                  height: 80px;
                  position: absolute;
                  top: 0;
                  left: 0;
                " />
            </div>
            <div class="" style="
                width: 138px;
                height: 40px;
                color: #fff;
                text-align: center;
                line-height: 40px;
                background-color: #ff7063;
                margin: 20px;
                border-radius: 5px;
              " @click="startLive">
              我要开始直播
            </div>
          </div>
          <div class="">
            <div class="" style="margin-top: 30px" v-loading="loading" v-if="tableData.length > 0">
              <div class="" v-for="(item, index) in tableData" :key="index" style="
            background-color: #fff;
            margin: 0 30px 15px;
            border-right: 6px solid #4b72f6;
            padding: 15px;
            box-sizing: border-box;
                border-radius: 10px;
                border: 1px solid #999;
          ">
                <div class="" style="font-size: 18px;display: flex;align-items: center;justify-content: space-between;">
                  <div class="" style="font-size: 18px;">
                    {{ item.match.match_time }}
                  </div>
                  <div class="" style="font-size: 18px;">
                    {{ item.match.league_name }}
                  </div>
                  <div class="" style="font-size: 18px;">
                    {{ item.status == 0 ? '审核中' : item.status == 1 ? '审核通过' : '审核驳回' }}
                  </div>
                </div>
                <div class="" style="display: flex; align-items: center">
                  <div class="" style="margin-left: 40px; width: 150px">
                    <div class="" style="color: #777; font-size: 18px">
                      {{ item.title }}
                    </div>
                  </div>
                  <div class="" style="flex: 1;" v-if="item.match">
                    <div class="" style="
                  display: flex;
                  align-items: center;
                  margin-bottom: 10px;
                  font-size: 16px;
                ">
                      <img :src="item.match.home_team_logo_text" alt="" style="
                    width: 36px;
                    height: 36px;
                    display: block;
                    margin-right: 5px;
                  " />
                      <div class="" style="width: 200px">
                        {{ item.match.home_team_name }}
                      </div>
                    </div>
                    <div class="" style="display: flex; align-items: center; font-size: 16px">
                      <img :src="item.match.away_team_logo_text" alt="" style="
                    width: 36px;
                    height: 36px;
                    display: block;
                    margin-right: 5px;
                  " />
                      <div class="" style="width: 200px">
                        {{ item.match.away_team_name }}
                      </div>
                    </div>
                  </div>
                  <el-button @click="handleClick1(item)" type="primary" v-if="item.show_stream">获取信息</el-button>
                  <el-button @click="handleClick2(item)" type="primary" v-if="item.show_start">上播</el-button>
                  <el-button @click="handleClick3(item)" type="primary" v-if="item.show_end">下播</el-button>
                </div>
              </div>
            </div>
            <div class="" style="display: flex;justify-content: center;" v-if="zhiboTotal > 10">
              <el-pagination layout="prev, pager, next" :total="zhiboTotal" background @prev-click="prevZhibo"
                @next-click="nextZhibo" @current-change="currentZhibbo">
              </el-pagination>
            </div>
          </div>
        </div>
        <div class="content-right" v-if="current == 8" style="padding: 0" v-loading="loading">
          <div class="" style="
              display: flex;
              align-items: center;
              justify-content: center;
              height: 300px;
            ">
            主播申请正在审核中,请稍后刷新重试
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" v-loading="loading">
      <div class="" style="box-sizing: border-box">
        <div class="" style="text-align: center">直播设置</div>
        <div class="" style="display: flex; align-items: center; margin-top: 20px">
          <div class="" style="width: 90px">
            <span style="color: red">*</span>直播类型:
          </div>
          <div class="">
            <div class="" style="border: 1px solid #eee; border-radius: 5px">
              <el-select v-model="type" placeholder="请选择" @change="typeChang" style="width: 500px">
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="" style="display: flex; align-items: center; margin-top: 20px">
          <div class="" style="width: 90px">
            <span style="color: red">*</span>选择比赛:
          </div>
          <div class="">
            <div class="" style="border: 1px solid #eee; border-radius: 5px">
              <el-select v-model="zhiboItem" placeholder="请选择" @change="zhiboChang" filterable style="width: 500px">
                <el-option v-for="item in saishilist" :key="item.id" :label="item.match_name" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="" style="color: #4B72F6;margin-left: 20px;">搜索剧本名称</div> -->
        </div>
        <div class="" style="display: flex; align-items: center; margin-top: 20px">
          <div class="" style="width: 90px">
            <span style="color: red">*</span>直播标题:
          </div>
          <div class="">
            <div class="" style="border: 1px solid #eee; border-radius: 5px">
              <el-input placeholder="请输入标题" v-model="title" style="width: 500px"></el-input>
            </div>
          </div>
        </div>
        <div class="" style="display: flex; align-items: center; margin-top: 20px">
          <div class="" style="width: 90px">
            <span style="color: red">*</span>直播公告:
          </div>
          <div class="">
            <div class="" style="border: 1px solid #eee; border-radius: 5px">
              <el-input placeholder="请输入公告" v-model="notice" style="width: 500px"></el-input>
            </div>
          </div>
        </div>
        <div class="" style="display: flex; align-items: center">
          <div class="" style="width: 90px">
            <span style="color: red">*</span>直播封面:
          </div>

          <div class="">
            <el-upload class="upload-demo" action="https://476.new.lingchuang.co/api/common/upload"
              :on-success="onSuccess4" :headers="headers" :show-file-list="false">
              <div class="" style="margin-top: 30px">
                <img :src="thumb" alt="" style="width: 198px; height: 128px; border: 1px solid #ddd" v-if="thumb" />
                <div class="" style="
                    width: 198px;
                    height: 128px;
                    border: 1px solid #ddd;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 5px;
                    margin-right: 20px;
                  " v-else>
                  <i class="el-icon-plus" style="font-size: 40px; color: #ddd"></i>
                </div>
                <div slot="tip" class="el-upload__tip">
                  仅支持上传 .png .jpg格式的文件
                </div>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="" style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 50px;
          ">
          <div class="" style="
              color: #4b72f6;
              border: 1px solid #4b72f6;
              width: 140px;
              height: 44px;
              text-align: center;
              line-height: 44px;
              border-radius: 5px;
              margin-right: 30px;
            " @click="dialogVisible = false">
            取消
          </div>
          <div class="" style="
              color: #fff;
              width: 140px;
              height: 44px;
              text-align: center;
              line-height: 44px;
              border-radius: 5px;
              background-color: #4b72f6;
            " @click="submitOpen">
            确定
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="showServe" v-loading="loading">
      <div class="" style="box-sizing: border-box">
        <div class="" style="text-align: center">直播信息</div>

        <div class="" style="display: flex; align-items: center; margin-top: 20px">
          <div class="" style="width: 90px">服务器地址:</div>
          <div class="" contenteditable="true">
            {{ pull }}
          </div>
          <div class="" style="color: #4b72f6;margin-left: 30px;" v-clipboard="pull" v-clipboard:success="Copy">
            <el-button type="primary">复制</el-button>
          </div>
        </div>
        <div class="" style="display: flex; align-items: center; margin-top: 20px">
          <div class="" style="width: 90px">推流码:</div>
          <div class="" contenteditable="true">
            {{ screct }}
          </div>
          <div class="" style="color: #4b72f6;margin-left: 30px;" v-clipboard="screct" v-clipboard:success="Copy">
            <el-button type="primary">复制</el-button>
          </div>
        </div>
        <div class="" style="display: flex; align-items: center; margin-top: 20px">
          <div class="" style="width: 90px">媒体源:</div>
          <div class="" contenteditable="true">
            {{ webUrl }}
          </div>
          <div class="" style="color: #4b72f6;margin-left: 30px;" v-clipboard="webUrl" v-clipboard:success="Copy">
            <el-button type="primary">复制</el-button>
          </div>
        </div>

      </div>
    </el-dialog>
  </div>
</template>
<script>
import NavTop from "../components/NavTopWhit.vue";
import {
  getUserInfo,
  editInfo,
  getsaichenglist,
  applyLiver,
  openLive,
  getPush,
  mylIveList,
  beginBo,
  sendCode,
  getConfreservationigList,
  getConfresguanzhuList,
  unfollow,
  getFeedList,
  bindph,
  startLive,
  shooseMatdh,
  endLive,
  getConfreservationig
} from "../api/user";
import Cookies from "js-cookie";
export default {
  components: {
    NavTop,
  },
  data() {
    return {
      check: true,
      headimg: "",
      realName: "",
      textarea: "",
      dialogVisible: false,
      tableData: [],
      frontCard: "",
      reverseCard: "",
      handHeld: "",
      zhiboTotal: 0,
      leftList: [
        {
          img: "https://476.new.lingchuang.co/my-home-on.png",
          name: "我的首页",
          img1: "https://476.new.lingchuang.co/my-home-off.png",
        },
        {
          img: "https://476.new.lingchuang.co/my-detail-on.png",
          name: "我的资料",
          img1: "https://476.new.lingchuang.co/my-detail-off.png",
        },
        {
          img: "https://476.new.lingchuang.co/my-concern-on.png",
          name: "我的关注",
          img1: "https://476.new.lingchuang.co/my-concern-off.png",
        },
        {
          img: "https://476.new.lingchuang.co/my-subscribe-on.png",
          name: "我的预约",
          img1: "https://476.new.lingchuang.co/my-subscribe-off.png",
        },
        {
          img: "https://476.new.lingchuang.co/my-feedback-on.png",
          name: "我的反馈",
          img1: "https://476.new.lingchuang.co/my-feedback-off.png",
        },
        // {
        //   img: 'https://476.new.lingchuang.co/my-private-chat-on.png',
        //   name: '我的私信',
        //   img1: 'https://476.new.lingchuang.co/my-private-chat-off.png'
        // }
      ],
      showDetail: false,

      current: 0,
      pageNum: 1,
      nickname: "",
      show: false,
      userInfo: {},
      LoginUser: {
        name: "",
        code: "",
      },
      buttonText: "获取验证码",
      showServe: false,
      birthday: "",
      gender: "0",
      options: [
        {
          value: "0",
          label: "保密",
        },
        {
          value: "1",
          label: "男",
        },
        {
          value: "2",
          label: "女",
        },
      ],
      list: [],
      notice: '',
      options1: [
        {
          value: "1",
          label: "足球",
        },
        {
          value: "2",
          label: "篮球",
        },
        {
          value: "3",
          label: "其他",
        }
      ],
      headimg1: '',
      headers: {
        token: localStorage.getItem("token"),
      },
      saishilist: [],
      loading: false,
      type: "", //开播设置篮球足球
      zhiboItem: "", //比赛对象获取流地址
      title: "", //直播标题
      thumb: "", //直播封面
      pull: "", //服务器地址
      webUrl: "", //网址视频
      screct: "", //推流码
      strams: "",
      push: "",
      couseList: [],
      zhiboItemId: "", //选择的比赛id
      yuyueList: [],
      guanzhuList: [],
      fankuiList: [],
      percentage: 50,
      experience: 1000,
      newPhone: "",
      fankuiTotal: 0,
      thumb1: ''
    };
  },
  created() {
    console.log("接收过来的参数", this.current);
    if (this.$route.query.current) {
      this.current = this.$route.query.current;
    }
    if (localStorage.getItem("user")) {
      this.getInfo();
      this.getmyLive();
      this.getscList();
      this.getyuyueList();
      this.getguanzhuList();
      this.getfankui();
    }
  },
  methods: {
    changCurrent(e) {
      console.log('切换current', e);
      this.current = e
      this.$router.push(0)
    },
    goyuyue(id) {
      getConfreservationig({
        id: id,
        type: 1
      }).then((res) => {
        this.getguanzhuList();
      });
    },
    qxyuyue(id) {
      getConfreservationig({
        id: id,
        type: 0
      }).then((res) => {
        this.getguanzhuList();
        this.getyuyueList();
      });
    },
    goliveDetail(userId) {
      this.$router.push({
        path: '/details',
        query: {
          userId: userId
        }
      })
    },
    Copy(e) {
      this.$message.success("复制成功");
    },
    Error(e) {
      this.$message.success("复制失败");
    },
    currentZhibbo(e) {
      console.log(e);
      this.pageNum = e
      this.getmyLive()
    },
    prevZhibo(e) {
      console.log(e);
      this.pageNum = e
      this.getmyLive()
    },
    nextZhibo(e) {
      console.log(e);
      this.pageNum = e
      this.getmyLive()
    },
    currentFankui(e) {
      console.log(e);
      this.pageNum = e
      this.getfankui()
    },
    prevFankui(e) {
      console.log(e);
      this.pageNum = e
      this.getfankui()
    },
    nextFankui(e) {
      console.log(e);
      this.pageNum = e
      this.getfankui()
    },
    bindPhone() {
      if (!this.newPhone) {
        this.$message("请输入新手机号");
        return;
      }
      bindph({
        mobile: this.newPhone,
        code: this.LoginUser.code
      }).then((res) => {
        this.notifySucceed("手机修改成功");
        setTimeout(() => {
          this.$router.go(0); // 刷新当前页面
        }, 1000);
      });
    },
    getfankui() {
      getFeedList({
        page: this.pageNum,
        limit: 10
      }).then((res) => {
        this.fankuiList = res.data.data
        this.fankuiTotal = res.data.total

      });
    },
    seeDetail(item) {
      this.feedItem = item
      this.showDetail = true
    },
    cancelGUanhzu(item) {
      unfollow({ id: item.uid }).then((res) => {
        this.getguanzhuList();
      });
    },
    getguanzhuList() {
      getConfresguanzhuList({
        page: 1,
        limit: 999
      }).then((res) => {
        this.guanzhuList = res.data.data
      });
    },
    getyuyueList() {
      getConfreservationigList({
        page: 1,
        limit: 999
      }).then((res) => {
        this.yuyueList = res.data.data
      });
    },
    getscList() {
      this.loading = true;
      let today = new Date();
      let obj = {};
      obj = {
        time: today.toISOString().slice(0, 10),
      };
      getsaichenglist({ date: obj.time }).then((res) => {
        this.loading = false;
        console.log(res);
        this.couseList = res.data;
      });
    },
    handleClick1(item) {
      beginBo({
        apply_id: item.id,
      }).then((res) => {
        if (res.code == 1) {
          this.pull = ''
          this.webUrl = ''
          this.screct = ''

          this.pull = res.data.server
          this.webUrl = res.data.stream_url
          this.screct = res.data.stream_key
          this.showServe = true

        }
      });
    },
    handleClick2(item) {
      startLive({
        apply_id: item.id,
      }).then((res) => {
        if (res.code == 1) {
          this.pageNum = 1
          this.getmyLive()
        }
      });
    },
    handleClick3(item) {
      endLive({
        apply_id: item.id,
      }).then((res) => {
        if (res.code == 1) {
          this.pageNum = 1

          this.getmyLive()

        }
      });
    },
    getmyLive() {
      this.loading = true;
      mylIveList({
        page: this.pageNum,
        limit: 10
      }).then((res) => {
        this.loading = false;
        this.tableData = res.data.data
        console.log('fgwejifuhwfgioewhg ', res);

        this.zhiboTotal = res.data.total
      });
    },
    startLive() {
      this.dialogVisible = true;
      this.type = "";
      this.zhiboItem = "";
      this.title = "";
      this.thumb = "";
      this.thumb1 = "";
      this.pull = "";
      this.pull1 = "";
      this.push = "";
      this.screct = "";
      this.zhiboItemId = "";
    },

    submitOpen() {
      let data = {
        title: this.title,
        cover_image: this.thumb1,
        match_id: this.zhiboItemId,
        notice: this.notice
      };
      openLive(data).then((res) => {
        if (res.code == 1) {
          this.notifySucceed("创建成功,请等待审核");
          this.dialogVisible = false;
          this.getmyLive();
        }
      });
    },
    submitApply() {
      if (!this.check) {
        this.$message({
          message: "请先同意协议",
          type: "warning",
        });
        return;
      }
      if (!this.realName) {
        this.$message({
          message: "请输入真实姓名",
          type: "warning",
        });
        return;
      }
      if (!this.frontCard) {
        this.$message({
          message: "请上传身份证正面照片",
          type: "warning",
        });
        return;
      }
      if (!this.reverseCard) {
        this.$message({
          message: "请上传身份证反面照片",
          type: "warning",
        });
        return;
      }
      if (!this.handHeld) {
        this.$message({
          message: "请上传手持身份证",
          type: "warning",
        });
        return;
      }
      let data = {
        nickname: this.realName,
        frontCard: this.frontCard,
        reverseCard: this.reverseCard,
        handHeld: this.handHeld,
        bio: this.textarea,
      };
      applyLiver(data).then((res) => {
        if (res.code == 1) {
          this.notifySucceed("申请成功,请等待审核");
          setTimeout(() => {
            this.$router.go(0); // 刷新当前页面
          }, 1000);
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    onSuccess1(files, filList) {
      this.frontCard = files.data.fullurl;
    },
    onSuccess2(files, filList) {
      this.reverseCard = files.data.fullurl;
    },
    onSuccess8(files, filList) {
      this.headimg = files.data.fullurl;
      this.headimg1 = files.data.url;

    },
    onSuccess3(files, filList) {
      this.handHeld = files.data.fullurl;
    },
    onSuccess4(files, filList) {
      this.thumb = files.data.fullurl;
      this.thumb1 = files.data.url;
    },
    getzbList() {
      this.loading = true;
      shooseMatdh({
        game_type: this.type
      }).then((res) => {
        this.saishilist = res.data;
        this.loading = false;
      });
    },
    typeChang(e) {
      console.log(e);
      this.type = e;
      this.zhiboItem = "";
      this.zhiboItemId = "";
      this.strams = "";
      this.pull = "";
      this.pull1 = "";
      this.screct = "";
      this.webUrl = "";
      this.push = "";
      this.getzbList();
    },
    editInfobtn() {
      let data = {
        nickname: this.nickname,
        bio: this.birthday,
        gender: 1,
        avatar: this.headimg1,
      };
      editInfo(data).then((res) => {
        this.notifySucceed("修改成功");
        this.$router.go(0); // 刷新当前页面
        this.getInfo();

      });
    },
    zhiboChang(e) {
      console.log("直播的", e);
      // this.zhiboItem = e.id
      this.zhiboItem = e.match_name;
      this.zhiboItemId = e.id;
    },
    dateChange(e) {
      console.log(e);
    },
    genderChang(e) {
      console.log(e);
      this.gender = e;
    },
    goFeed() {
      this.$router.push("/goods");
    },
    goRet() {
      this.$router.push("/help");
    },
    goLOk() {
      this.$router.push("/look");
    },
    getInfo() {
      getUserInfo().then((res) => {
        console.log("mine的用户信息", res.data);
        this.userInfo = res.data;
        this.nickname = this.userInfo.nickname;
        this.birthday = this.userInfo.birthday;
        this.gender = String(this.userInfo.gender);
        this.headimg = this.baseUrl + this.userInfo.avatar;
        this.headimg1 = this.userInfo.avatar;
        if (res.data.nextLevel.experience) {
          this.experience = res.data.nextLevel.experience;
          this.percentage = ((res.data.experience / this.experience) * 100).toFixed(0)
        }
      });
    },
    godetail() {
      this.show = true;
    },
    goEdit() {
      this.$router.push("/edit");
    },
    changtab(index) {
      this.current = index;
      this.page = 1
      if (index == 0) {
        this.show = false;
      }
    },
    // 左箭头
    leftSlide(item) {
      // 保存滚动盒子左侧已滚动的距离
      let left = this.$refs.wrapperCon[item].scrollLeft;
      console.log(this.$refs.wrapperCon[item], "left");
      let num = 0;
      clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        //   !left:已经滚动到最左侧
        //   一次性滚动距离（可调节）
        if (!left || num >= 260) {
          // 停止滚动
          clearInterval(this.timer);
          this.timer = null;
          return;
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon[item].scrollLeft -= 5;
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += 30;
      }, 20);
      // 20：速度（可调节）
    },
    // 右箭头
    rightSlide(item) {
      // 保存滚动盒子左侧已滚动的距离
      let left = this.$refs.wrapperCon[item].scrollLeft;
      console.log(this.$refs.wrapperCon[item], "left");
      // 保存元素的整体宽度
      let scrollWidth = this.$refs.wrapperCon[item].scrollWidth;
      // 保存元素的可见宽度
      let clientWidth = this.$refs.wrapperCon[item].clientWidth;
      let num = 0;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        // 已经滚动距离+可见宽度
        // left+clientWidth>=scrollWidth：滚动到最右侧
        // num>=300一次性滚动距离
        if (left + clientWidth >= scrollWidth || num >= 260) {
          clearInterval(this.timer);
          return;
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon[item].scrollLeft += 5;
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += 30;
      }, 20);
      // 20：速度（可调节）
    },
    getCode() {
      // const userNameRule = /^1[3456789]\d{9}$/;
      // if (!userNameRule.test(this.LoginUser.name)) {
      //   this.$message({
      //     message: '请输入正确手机号',
      //     type: 'warning'
      //   });
      //   return
      // }
      if (!this.LoginUser.name) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (this.buttonText != "获取验证码") {
        this.$message({
          message: "倒计时结束之后再发送",
          type: "warning",
        });
        return;
      }
      sendCode({
        mobile: this.LoginUser.name,
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          console.log(res);
          this.sended = true;
          this.buttonText = "已发送";
          let countDown = 60;
          const timer = setInterval(() => {
            if (countDown > 0) {
              this.buttonText = `${countDown}s 后重试`;
            } else {
              this.sended = false;
              this.buttonText = "获取验证码";
              clearInterval(timer);
            }
            countDown--;
          }, 1000);
          console.log("验证码已发送");
        } else {
          this.notifyError(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.content {
  width: 1114px;
  min-height: 557px;
  margin: 64px auto 30px;
}

.content-top {
  padding-top: 48px;
}

.content-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 16px;
}

.content-left .left-bom {
  width: 160px;
  background: #ffffff;
  box-shadow: 0px 1px 12px 0px rgba(153, 153, 153, 0.08);
  box-sizing: border-box;
  padding-top: 30px;
}

.content-left .left-bom .left-item {
  padding: 16px 0;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
  padding-left: 20px;
}

.active {
  background-color: #4b72f6;
  color: #fff;
}

.content-right {
  background: #ffffff;
  box-shadow: 0px 1px 12px 0px rgba(153, 153, 153, 0.08);
  width: 942px;
  min-height: 600px;
  padding: 24px;
  box-sizing: border-box;
}

/deep/.el-progress-bar__outer {
  height: 12px !important;
}

.line {
  height: 60px;
  width: 1px;
  background-color: #eee;
  margin: 0 80px;
}

.el-form {
  width: 300px;
  margin: 80px auto;
}

/*隐藏滚动条*/
.scroll_wrapper1::-webkit-scrollbar {
  display: none;
}
</style>
